import api from '@/apis'
import type { GachaRecentWinner } from '@/types/gacha'

interface RecentWinnersResponse {
  contents: GachaRecentWinner[]
  totalElements: number
  totalPages: number
  number: number
  size: number
}

export const apiGetGachaRecentWinners = async (
  gachaEventId: number,
  page: number,
  size: number
): Promise<GachaRecentWinner[]> => {
  const result = await api.get<RecentWinnersResponse | null>(`/gachas/${gachaEventId}/draw/recent-winners`, {
    params: { page, size },
  })
  return result?.contents ?? []
}
